import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import moment from "moment";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import Delete from "../../images/icons/delete.svg";

const DeleteMicrosoftEventModal = ({
    deleteMicrosoftEventModalOpen,
    setDeleteMicrosoftEventModalOpen,
    setSelectedEvents,
    isDeleting,
    setIsDeleting,
    selectedMicrosoftEventForDelete,
    setExpandedEventIndex,
    setSelectedMicrosoftEventForDelete,
    refetchEvents,
    refetchSelectedMicrosoftEvents,
    setModalIsOpen,
    token,
}) => {
    const [deleteScope, setDeleteScope] = useState('thisEvent');
    const handleDeleteMicrosoftEvent = async (
        eventId,
        microsoftUserId,
        deleteScope = 'thisEvent',
        instanceDate = null
    ) => {
        try {
            setIsDeleting(true);

            const formattedInstanceDate = instanceDate
                ? moment(instanceDate).utc().format()
                : null;

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    deleteScope,
                    instanceDate: formattedInstanceDate,
                    microsoftUserId,
                },
            };

            await axios.delete(`/api/microsoft-calendar/events/delete/${eventId}`, config);

            const scopeMessage = deleteScope === 'thisEvent' ? 'this event only' : 'this and following events';
            global.config.activityLog(
                window.location.href,
                'Event Deletion',
                `Microsoft Calendar event "${eventId}" deleted successfully (${scopeMessage})`
            );

            toast.success(`Microsoft Calendar event deleted successfully (${scopeMessage})`, {
                position: 'bottom-right',
                autoClose: 2000,
            });

            refetchSelectedMicrosoftEvents?.();
            refetchEvents?.();
            // handleCloseCreateModal?.();
            // handleCloseCreateEventModal?.();
            setModalIsOpen(false);
            setExpandedEventIndex(null);
            setSelectedEvents([]);
            handleCancelDeleteMicrosoftEvent?.();
            document.body.classList.remove('ReactModal__Body--open');
        } catch (error) {
            console.error('Error deleting Microsoft Calendar event:', error);
            global.config.slackMessage?.(error.toString());

            const errorMessage = error?.response?.data?.message || 'Failed to delete Microsoft Calendar event';
            toast.error(errorMessage, {
                position: 'bottom-right',
                autoClose: 2000,
            });
        } finally {
            setIsDeleting(false);
        }
    };

    const handleCancelDeleteMicrosoftEvent = () => {
        setDeleteMicrosoftEventModalOpen(false);
        setDeleteScope('thisEvent');
        setSelectedMicrosoftEventForDelete(null);
        document.body.classList.remove("ReactModal__Body--open");
    };

    const patternType = selectedMicrosoftEventForDelete?.extendedProps?.recurrence?.pattern?.type;
    const isRecurring = patternType || false;

    return (
        <Modal
            className="center-modal"
            isOpen={deleteMicrosoftEventModalOpen}
            onRequestClose={!isDeleting ? handleCancelDeleteMicrosoftEvent : undefined}
            contentLabel="Confirm Delete Microsoft Event"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <div className="modal-close-invite outter-modal-main">
                    <a onClick={handleCancelDeleteMicrosoftEvent} disabled={isDeleting}>
                        <img src={crossImage} alt="Close Icon" />
                    </a>
                </div>
                {/* <h2>{isRecurring ? "Delete this recurring event?" : "Confirm Delete"}</h2> */}
                <h2>{isRecurring ? `Delete recurring event for ${selectedMicrosoftEventForDelete?.calendarEmail}?` : `Delete event for ${selectedMicrosoftEventForDelete?.calendarEmail}?`}</h2>
                {isRecurring ? (
                    <>
                        <div className="delete-options-recuring">
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    value="thisEvent"
                                    checked={deleteScope === 'thisEvent'}
                                    onChange={() => setDeleteScope('thisEvent')}
                                    disabled={isDeleting}
                                />
                                <span>This event only</span>
                            </label>
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    value="thisAndFollowing"
                                    checked={deleteScope === 'thisAndFollowing'}
                                    onChange={() => setDeleteScope('thisAndFollowing')}
                                    disabled={isDeleting}
                                />
                                <span>This and following events</span>
                            </label>
                        </div>
                    </>
                ) : (
                    <p>Are you sure you want to delete this event?</p>
                )}
                <div className="delete-modal-buttons">
                    <button
                        onClick={() => {
                            const instanceDate = selectedMicrosoftEventForDelete.start
                                ? moment(selectedMicrosoftEventForDelete.start).utc().toISOString()
                                : null;
                            console.log('Selected instanceDate:', instanceDate);
                            handleDeleteMicrosoftEvent(
                                selectedMicrosoftEventForDelete.extendedProps.microsoftEventId,
                                selectedMicrosoftEventForDelete.extendedProps.microsoftUserId,
                                deleteScope,
                                instanceDate
                            );
                        }}
                        disabled={isDeleting || (isRecurring && !deleteScope)}
                        className="modal-btn modal-btn-calendar delete"
                    >
                        {isDeleting ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="70px" height="18px" />
                            </div>
                        ) : (
                            <>
                                Delete
                                <img src={Delete} alt="Delete" />
                            </>
                        )}
                    </button>
                    <button
                        onClick={handleCancelDeleteMicrosoftEvent}
                        disabled={isDeleting}
                        className="modal-btn modal-btn-calendar cancel"
                    >
                        {isDeleting ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="60px" height="18px" />
                            </div>
                        ) : (
                            "Cancel"
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteMicrosoftEventModal;